module.exports = __webpack_public_path__ + "static/media/awaiting_stopwatch.9482c157.svg";